/* 🤖 this file was generated by script */
export const wsolidiconArrowCircleBrokenLeft = {
  name: 'arrow_circle_broken_left',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M18.88 7.73c.11.42.16.62.1.85a1 1 0 0 1-.37.47c-.2.12-.45.12-.94.12h-9l1.92-1.91a.83.83 0 0 0-1.18-1.18L6.08 9.4a.83.83 0 0 0 0 1.18l3.33 3.33a.83.83 0 0 0 1.18-1.18l-1.91-1.9h9c.48 0 .73 0 .93.11.16.1.31.3.36.47.07.23.02.43-.09.85a9.17 9.17 0 1 1 0-4.54"/></svg>`,
  iconStyle: 'solid',
};
